import getExtensibilityState from "../store/getExtensibilityState";
import type TaskPaneType from "../store/schema/TaskPaneType";
import { mutatorAction } from "satcheljs";
import getTabIdFromWindow from "../store/getTabIdFromWindow";
import type { MailboxInfo } from "owa-client-types";
import { addinTracker } from "../utils/AddinTracker";

const terminateTaskPaneAddinCommandMutator: (type: TaskPaneType, targetWindow: Window, mailboxInfo: MailboxInfo) => void = mutatorAction("terminateTaskPaneAddin", function terminateTaskPaneAddin(type: TaskPaneType, targetWindow: Window, mailboxInfo: MailboxInfo): void {
    const { taskPanes } = getExtensibilityState(mailboxInfo);
    const tabId: string = getTabIdFromWindow(targetWindow);
    
    if (taskPanes.has(tabId)) {
        const controlId = taskPanes.get(tabId)?.get(type)?.controlId;
        if (controlId) {
            addinTracker.endAddinTracking(controlId, "AddinLaunch", "Completed", mailboxInfo);
        }
        taskPanes.get(tabId)?.delete(type);
        if (taskPanes.get(tabId)?.size === 0) {
            taskPanes.delete(tabId);
        }
    }
});
export default terminateTaskPaneAddinCommandMutator;
